var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"element-modal"}},[(_vm.element && _vm.element.value == 1)?_c('div',{staticClass:"element-modal",style:(`z-index: ${_vm.zIndex}`)},[_c('div',{staticClass:"container",style:(`width: ${_vm.width}`)},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }